export const getUserActivity = (last_login: string) => {
  const lastLoginDate = new Date(last_login);
  const currentDate = new Date();
  const timeDifference = currentDate.getTime() - lastLoginDate.getTime();
  const daysDifference = Math.floor(timeDifference / (1000 * 3600 * 24));

  if (daysDifference === 0) {
    return 'Active Now';
  } else if (daysDifference === 1) {
    return 'Last Active Yesterday';
  } else {
    return `Active on ${lastLoginDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })}, ${lastLoginDate.getDate()} ${lastLoginDate.toLocaleString('default', { month: 'short' })} ${lastLoginDate.getFullYear()}`;
  }
};
